
<div class="flex-row row  stdTheme" style="width: 100%;margin-left: 0px; margin-right: 0px">
<!-- Icône clavier pour activer saisie manuelle -->
    <div class="col-lg-12 col-xs-12">
        <button mat-icon-button color="primary" (click)="toggleScannerInput()" 
                title="{{'INVENTORY.MANUAL_ENTRY' | translate}}">
            <mat-icon>keyboard</mat-icon>
        </button>
    </div>
    <div class="col-lg-12 col-xs-12">
        <input #scannerInput
            type="text"
            (input)="onInputScanner($event)"
            (keydown.enter)="finishManualInput()"
            autocomplete="off"
            autofocus
            [class.hiddenScanner]="!scannerVisible">
            <div class="input-group-append inputTheme">
                <p>{{'INVENTORY.SCANNED_BARCODE' | translate}} : {{ scannedCode }}</p>       
            </div>   
    </div>
</div>
<!--
<div class="flex-row row  stdTheme" style="width: 100%;margin-left: 0px; margin-right: 0px">
    <div class="col-lg-12 col-xs-12">
        <input #scannerInput
            type="text"
            (input)="onInputScanner($event)"
            style="position: absolute; left:-9999px; opacity:0;"
            autocomplete="off"
            
            autofocus>
    </div>
    <div class="col-lg-12 col-xs-12">
        <span class="inputTheme" >{{'INVENTORY.SCANNED_BARCODE' | translate}} : {{ scannedCode }}</span>       
    </div>
</div>
-->
<!--
<input
  #scannerInput
  type="text"
  style="position:absolute; left:-9999px; opacity:0;"
  autocomplete="off"
/>

<p>
  {{ 'INVENTORY.SCANNED_BARCODE' | translate }} :
  {{ scannedCode }}
</p>
-->